export function formatNumCommande(numCommande: string) {
  const numSplit = numCommande.split('-');
  return numSplit[2];
}

export function formatDateHeure(value: string) {
  const valueSplit = value.split(' ');
  const date = formatDate(valueSplit[0]);
  const heureSplit = valueSplit[1].split(':');
  const heure = heureSplit[0] + 'h' + heureSplit[1];
  return date + ' à ' + heure;
}

export function formatDate(date: string) {
  const dateSplit = date.split('-');
  return dateSplit[2] + '/' + dateSplit[1] + '/' + dateSplit[0];
}

/**
 * TODO: A compléter
 *
 * Fonction renplaçant les caractères héxadécimaux
 *
 * @param {string} string
 * @returns {string}
 */
export function replaceHexadecimalCharacter(string: string) {
  const tab: Record<string, string> = { '&eacute;': 'é', '&egrave;': 'è', '&agrave;': 'à' };
  let newString = string;

  for (const index in tab) {
    if (string.indexOf(index)) {
      newString = newString.replace(index, tab[index]);
    }
  }

  return newString;
}

export function getEtatCommande(etat: string) {
  return replaceHexadecimalCharacter(etat);
}

export function defineValueForSelectOptionPayment(label: string) {
  let value = label;

  if (label === 'Bon de commande administratif') {
    value = 'Virement Administration';
  }
  return value;
}
